var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ob1-rating",
      style: _vm.ob1RatingStyle,
      attrs: { title: _vm.title },
    },
    [
      _c("span", {
        staticClass: "ob1-stars",
        attrs: { "data-rating": _vm.roundedAverage, "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c(
        _vm.link && _vm.text ? "a" : "span",
        {
          tag: "component",
          attrs: { href: _vm.link || undefined },
          on: {
            click: function ($event) {
              _vm.link ? _vm.clickHandler($event) : null
            },
          },
        },
        [
          _c("span", { staticClass: "ob1-score", style: _vm.ob1ScoreStyle }, [
            _c("span", { staticClass: "visually-hidden" }, [_vm._v("Note ")]),
            _vm._v(_vm._s(_vm.formattedAverage)),
          ]),
          _c("span", { staticClass: "ob1-score-max" }, [_vm._v("/5")]),
          _vm._v(" "),
          _c("span", { staticClass: "ob1-rating-label" }, [
            _vm._v(_vm._s(_vm.text)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }